import { ChakraFlex, ChakraText, FAIconName, Icon } from '@equip.health/ui';

import { ParsedCitation, citationPillLabel } from './maiChat.util';

interface MaiChatChartCitationPillProps {
  citation: ParsedCitation;
}

const MaiChatChartCitationPill = ({
  citation,
}: MaiChatChartCitationPillProps) => (
  <ChakraFlex
    data-testid="mai-chat-chart-citation-pill"
    alignItems="center"
    gap="5px"
    padding="3px 9px"
    borderRadius="999px"
    background="neutral.background.secondary"
    border="1px solid"
    borderColor="neutral.line"
  >
    <Icon
      name={FAIconName.clipboardMedicalRegular}
      color="neutral.tertiary"
      size="sm"
    />
    <ChakraText color="neutral.secondary" fontSize="11px" fontWeight="500">
      {citationPillLabel(citation)}
    </ChakraText>
  </ChakraFlex>
);

export default MaiChatChartCitationPill;
